import NotificationsIcon from "@mui/icons-material/Notifications";

export default () => <NotificationsIcon />;
